import { useMemo } from 'react';
import { Camera } from '../utils/cameraUtils';

const GRID_SIZE = 20; // The size of the grid squares in world units

/**
 * Hook to generate style for an infinite, pannable, and zoomable background.
 * @param camera - The camera state (position and scale).
 * @returns React CSS properties for the background.
 */
export const useInfiniteBackground = (camera: Camera) => {
  const backgroundStyle = useMemo(() => {
    const { scale, position } = camera;

    // Adjust grid size and dot size based on zoom
    const bgSize = GRID_SIZE * scale;
    const dotSize = Math.max(1, 1 * scale); // Ensure dot is at least 1px
    const dotColor = 'rgba(0, 0, 0, 0.1)';

    return {
      backgroundSize: `${bgSize}px ${bgSize}px`,
      backgroundImage: `radial-gradient(circle, ${dotColor} ${dotSize}px, transparent ${dotSize}px)`,
      backgroundPosition: `${position.x}px ${position.y}px`,
    };
  }, [camera]);

  return backgroundStyle;
};